import { useEffect, useState } from 'react';

// Measures the live aspect ratio (width / height) of a slot on the page canvas
// so the photo navigator can match the slot's shape. Returns null until measured.
// The slot's pixel size only comes from layout (CSS grid + responsive page), so
// it's read from the DOM and re-measured on resize rather than derived from data.
export function useSlotAspect(pageId: string | null, slotKey: string | null): number | null {
  const [aspect, setAspect] = useState<number | null>(null);

  useEffect(() => {
    setAspect(null);
    if (!pageId || !slotKey) return;
    const slot = document.querySelector<HTMLElement>(
      `.ins-canvas-page .ins-slot[data-slot-key="${slotKey}"]`,
    );
    if (!slot) return;
    // Measure the photo's frame, not the slot — the slot also holds the caption
    // below it, which is not part of the shape the photo is fitted into.
    const el = slot.querySelector<HTMLElement>('.ins-slot-frame') ?? slot;

    const measure = () => {
      const r = el.getBoundingClientRect();
      if (r.width > 0 && r.height > 0) setAspect(r.width / r.height);
    };
    measure();

    if (typeof ResizeObserver === 'undefined') return;
    const observer = new ResizeObserver(measure);
    observer.observe(el);
    return () => observer.disconnect();
  }, [pageId, slotKey]);

  return aspect;
}
